import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './project-env-edit-form.constant';

const en = {};

export type ProjectEnvEditFormTranslations = typeof en;

@NgModule()
export class ProjectEnvEditFormTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
